// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"add-to-linkedin-menu-item_menu-item__Bzl6e"};